<div *ngIf="yourBookingScreen.isMapped" class="yourBookingScreenDiv">
  <div class="ordviewpn">
    <div class="row mt-2">
      <div class="col-md-12 flex flexAside">
        <h3>Your Booking</h3>
        <div class="txtRt flexAside">
          <div class="">
            <ng-template [ngIf]="yourBookingScreen.booking!.bookingStatus === 'HOLD'">
              <label class="smx me-3">
                Payment Time Limit<br />
                {{ yourBookingScreen.booking!.paymentLimitTime }}
              </label>
            </ng-template>
          </div>
          <label class="h3 ms-2">
            {{ yourBookingScreen.booking!.pnrNumber }} | {{ yourBookingScreen.booking!.bookingStatus }}
            <ng-template [ngIf]="yourBookingScreen.booking.isDisrupted">
              <span class="redText">| DISRUPTED</span>
            </ng-template>
          </label>
        </div>
      </div>
      <p *ngIf="yourBookingScreen.booking.isDisrupted" class="redText ms-3">Your Booking has been Changed to:</p>
    </div>
    <!-- fligth segments -->
    <div class="air-offer card">
      <div class="pt-2 pb-2">
        <div class="ms-3">
          <ng-template [ngIf]="yourBookingScreen.booking!.boundAirlineOffer.length > 0">
            <div
              *ngFor="let boundAirlineOffer of yourBookingScreen.booking!.boundAirlineOffer; let boundOfferIndex = index; let boundOfferLastIndex = last; let boundOfferFirstIndex = first">
              <div
                *ngFor="let airlineOffer of boundAirlineOffer.flightsDetails; let airlineOfferIndex = index; let lastIndex = last; let flightLastIndex = last; let flightFirstIndex = first">
                <div class="row">
                  <div class="col-sm-10 dashLt">
                    <div class="od2">
                      <div class="row p-1">
                        <div class="col-sm-1">
                          <img *ngIf="getFlightLogoUrl(airlineOffer.airlineName) !== ''" class="pt-10"
                            [src]="getFlightLogoUrl(airlineOffer.airlineName)" />
                        </div>
                        <div class="col-sm-1 wd110 pd-0">
                          <span class="pad-title">{{ airlineOffer.economyType }} </span><br />
                        </div>
                        <div class="col-sm-1 pl-0 pr-2 minw60">
                          <div class="flt-date">{{ airlineOffer.departureDate }}</div>
                        </div>
                        <div class="col-sm-2">
                          <div class="fltgrp">
                            <div class="fl-time">{{ airlineOffer.departureTimeIn24H }}</div>
                            <div class="fl-airpt">
                              <div class="sm-text">{{ airlineOffer.departureAirportName }}</div>
                              {{ airlineOffer.departureAirportCode }}
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 pd-0">
                          <div style="text-align: center">
                            <span style="font-size: 12px"> {{ airlineOffer.duriation }} </span>
                            <ul class="Leg-line"></ul>
                            <span style="font-size: 12px; color: #074e11"> {{ airlineOffer.airlineId }}{{
                              airlineOffer.airlineNumber }} | {{ airlineOffer.flightType }} | </span>
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <div class="fl-time">{{ airlineOffer.arrivalTimeIn24H }}</div>
                          <div class="fl-airpt">
                            <div class="sm-text">{{ airlineOffer.arrivalAirportName }}</div>
                            {{ airlineOffer.arrivalAirportCode }}
                          </div>
                        </div>
                      </div>

                      <div class="small-text col-sm-12">Operated by {{ airlineOffer.operatingCarrier }}</div>

                      <ng-template
                        [ngIf]="!yourBookingScreen.booking.isDisrupted && yourBookingScreen.booking.bookingStatus !== 'CANCELLED'">
                        <ng-template [ngIf]="fareRulesIds.length > 0">
                          <div id="main">
                            <div class="accordion" id="faq">
                              <div id="faqhead1">
                                <a href="#" class="btn-header-link" [class.collapsed]="!boundAirlineOffer.displayRule"
                                  (click)="toggleRule(boundOfferIndex)">
                                  <span class="pl-2">Rules</span>
                                </a>
                              </div>
                              <ng-template [ngIf]="flightLastIndex && boundAirlineOffer.displayRule">
                                <div class="srchODpn">
                                  <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                      <a class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                                        [href]="'#pills-home' + boundOfferIndex"  role="tab"
                                        aria-controls="pills-home" aria-selected="true">
                                        Pre Departure
                                      </a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                      <a class="nav-link ms-2" id="pills-profile-tab" data-bs-toggle="pill"
                                        [href]="'#pills-profile' + boundOfferIndex"  role="tab"
                                        aria-controls="pills-profile" aria-selected="false">
                                        Post Departure
                                      </a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                      <a class="nav-link ms-2" id="pills-contact-tab" data-bs-toggle="pill"
                                        [href]="'#pills-contact' + boundOfferIndex"  role="tab"
                                        aria-controls="pills-contact" aria-selected="false">
                                        No Show
                                      </a>
                                    </li>
                                  </ul>
                                  <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active" [attr.id]="'pills-home' + boundOfferIndex"
                                      role="tabpanel" aria-labelledby="pills-home-tab">
                                      <div *ngFor="let rule of boundAirlineOffer.preDepatureRules" class="pl-2">
                                        <div>{{ rule.changeRuleLable | uppercase }}</div>
                                        <div>
                                          {{ rule.changePenaltyRemark }} <b>{{ rule.changePenaltyAmount }}</b>
                                        </div>
                                        <div>{{ rule.cancellationRuleLabel | uppercase }}</div>
                                        <div>
                                          {{ rule.cancellationPenaltyRemark }} <b>{{ rule.cancellationPenaltyAmount
                                            }}</b>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tab-pane fade p-2" [attr.id]="'pills-profile' + boundOfferIndex"
                                      role="tabpanel" aria-labelledby="pills-profile-tab">
                                      <div *ngFor="let rule of boundAirlineOffer.postDepatureRules" class="pl-2">
                                        <div>{{ rule.changeRuleLable | uppercase }}</div>
                                        <div>
                                          {{ rule.changePenaltyRemark }} <b>{{ rule.changePenaltyAmount }}</b>
                                        </div>
                                        <div>{{ rule.cancellationRuleLabel | uppercase }}</div>
                                        <div>
                                          {{ rule.cancellationPenaltyRemark }} <b>{{ rule.cancellationPenaltyAmount
                                            }}</b>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tab-pane fade p-2" [attr.id]="'pills-contact' + boundOfferIndex"
                                      role="tabpanel" aria-labelledby="pills-contact-tab">
                                      <div *ngFor="let rule of boundAirlineOffer.noShowRules" class="pl-2">
                                        <div>{{ rule.changeRuleLable | uppercase }}</div>
                                        <div>
                                          {{ rule.changePenaltyRemark }} <b>{{ rule.changePenaltyAmount }}</b>
                                        </div>
                                        <div>{{ rule.cancellationRuleLabel | uppercase }}</div>
                                        <div>
                                          {{ rule.cancellationPenaltyRemark }} <b>{{ rule.cancellationPenaltyAmount
                                            }}</b>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </ng-template>

                        <ng-template [ngIf]="penaltyRulesIds.length > 0">
                          <div id="main">
                            <div class="accordion" id="faq">
                              <div id="faqhead1">
                                <a href="#" class="btn-header-link" [class.collapsed]="!boundAirlineOffer.displayRule"
                                  (click)="toggleRule(boundOfferIndex)">
                                  <span class="pl-2">Rules</span>
                                </a>
                              </div>
                              <ng-template [ngIf]="flightLastIndex && boundAirlineOffer.displayRule">
                                <div class="mt-2 ms-4 p-2 srchODpn">
                                  <div *ngFor="let rules of boundAirlineOffer.rule">
                                    <label>{{ rules?.changeRuleLabel | uppercase }}</label>
                                    <br />
                                    {{ rules?.changePenaltyRemark }}
                                    <br />
                                    <label>{{ rules?.cancellationRuleLabel | uppercase }}</label>
                                    <br />
                                    {{ rules?.cancellationPenaltyRemark }}
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </ng-template>
                      </ng-template>
                    </div>
                  </div>
                  <!-- add buttons -->
                  <div class="col-sm-2 p-3">
                    <ng-template [ngIf]="boundOfferFirstIndex && flightFirstIndex">
                      <div class="upPatch"></div>
                    </ng-template>
                    <ng-template
                      [ngIf]="yourBookingScreen.booking!.bookingStatus === 'CONFIRMED' && !yourBookingScreen.booking.isDisrupted">
                      <ng-template [ngIf]="!airlineOffer.isSeatAlreadyAdded">

                        <button *ngIf="!isSMEUser" type="button" role="button"
                          (click)="manageSeats(airlineOfferIndex, boundOfferIndex)"
                          class="ba-btn ba-btn-smx-vthin mb-3 ba-btn-w90">
                          Add <i class="baIcn ba-flight-seat ba-seat2x"></i>
                        </button>
                      </ng-template>
                      <ng-template
                      [ngIf]="!isSMEUser && airlineOffer.isSeatAlreadyAdded">
                        <button type="button" role="button" (click)="manageSeats(airlineOfferIndex, boundOfferIndex)"
                          class="ba-btn ba-btn-smx-vthin mb-3 ba-btn-w90">

                          Change <i class="baIcn ba-flight-seat ba-seat2x"></i>
                        </button>
                        <button type="button" role="button" data-bs-toggle="modal" data-bs-target="#CancelSeats"
                          (click)="cancelSeats(airlineOfferIndex, boundOfferIndex)"
                          class="ba-btn ba-btn-smx-vthin ba-btn-w90 mb-3">
                          Cancel <i class="baIcn ba-flight-seat ba-seat2x"></i>
                        </button>
                      </ng-template>
                    </ng-template>

                    <ng-template [ngIf]="boundOfferLastIndex && flightLastIndex">
                      <div class="downPatch-outbound-your-booking"></div>
                    </ng-template>
                  </div>
                  <!-- add buttons -->
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <!----------------------------------------- passenger details ------------------------>
    <div>
      <app-passenger-details></app-passenger-details>
    </div>
    <ng-template [ngIf]="yourBookingScreen.displayConfirmBookingForm">
      <app-confirm-booking-screen></app-confirm-booking-screen>
    </ng-template>
    <ng-template [ngIf]="yourBookingScreen.displayCancelGetRefundForm">
      <app-cancel-booking-refund-quote-screen></app-cancel-booking-refund-quote-screen>
    </ng-template>
  </div>
</div>

<!-- cancel held booking -->
<div class="modal cancelPopup" id="CancelSeats" tabindex="-1" role="dialog" aria-hidden="true"
  aria-labelledby="cancelBookingPopupTitle">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="CancelSeatsTitle">CANCEL SEATS?</h5>
        <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">Confirm Cancel Seats For This Flight</div>
      <div class="modal-footer">
        <div class="jconfirm-buttons">
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-default"
            (click)="deleteSeats()">YES</button>
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-default">NO</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- cancel held booking -->